module.exports = __webpack_public_path__ + "img/_dsc8181.1d5bba5f.jpg";